import { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import Toast from './Toast';

const ToastContext = createContext();
const TOAST_MS = 5000;

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const dismiss = useCallback(() => {
    clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  const showToast = useCallback(({ message, actionLabel, onAction }) => {
    clearTimeout(timerRef.current);
    setToast({ message, actionLabel, onAction });
    timerRef.current = setTimeout(() => setToast(null), TOAST_MS);
  }, []);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <ToastContext.Provider value={{ showToast, dismiss }}>
      {children}
      {toast && (
        <Toast
          message={toast.message}
          actionLabel={toast.actionLabel}
          onAction={() => {
            if (toast.onAction) toast.onAction();
            dismiss();
          }}
        />
      )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
